/*
 * @forgerock/javascript-sdk
 *
 * constants.ts
 *
 * Copyright (c) 2020 ForgeRock. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
/** @hidden */
const DEFAULT_TIMEOUT = 5 * 1000;
const DEFAULT_OAUTH_THRESHOLD = 30 * 1000;
const PREFIX = 'FR-SDK';

export { DEFAULT_OAUTH_THRESHOLD, DEFAULT_TIMEOUT, PREFIX };
